import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as componentStyles } from './view.scss';
import { unsafeCSS } from 'lit';

export const styles = [unsafeCSS(`${commonStyles}`), unsafeCSS(`${componentStyles}`)];
